import app from '@/config/configApp';
import Cards from '@/components/cards/frame/CardsFrame.vue';
import FeatherIcons from '@/components/utilities/featherIcons.vue';
import Alerts from '@/components/alerts/Alerts.vue';
import Button from '@/components/buttons/Buttons.vue';
import BtnGroup from '@/components/buttons/ButtonsGroup.vue';
import CalendarButton from '@/components/buttons/CalendarButton.vue';
import ExportButton from '@/components/buttons/ExportButton.vue';
import ShareButton from '@/components/buttons/ShareButton.vue';
import PageHeader from '@/components/pageHeaders/PageHeaders.vue';
import GoogleBasicPieChart from '@/components/charts/GoogleBasicPieChart.vue';
import GoogleBasicBarChart from '@/components/charts/GoogleBasicBarChart.vue';
// import CreateProject from '@/view/apps/project/overview/CreateProject'
import Drawer from '@/components/drawer/Drawer.vue';

// import {
//   GoogleBasicBarChart,
//   GoogleMaterialBarChart,
//   GoogleStackedChart,
//   GoogleCustomColorChart,
//   GoogleComboChart,
//   GoogleLineChart,
//   GoogleMultiLineChart,
//   GoogleBasicPieChart,
//   Google3dPieChart,
//   BubbleChart,
// } from '@/components/charts/googleChart.vue'

// import { ChartContainer } from '@/view/dashboard/style'
import Cascader from '@/components/cascader/Cascader.vue';
import Heading from '@/components/heading/Heading.vue';
import AutoComplete from '@/components/autoComplete/autoComplete.vue';
import Dropdown from '@/components/dropdown/Dropdown.vue';
import Popover from '@/components/popup/Popup.vue';
import Modal from '@/components/modals/Modals.vue';

[
  Heading,
  Cards,
  GoogleBasicPieChart,
  GoogleBasicBarChart,
  // {
  //   name: 'ChartContainer',
  //   ...ChartContainer,
  // },

  // {
  //   name: 'GoogleMaterialBarChart',
  //   ...GoogleMaterialBarChart,
  // },
  // {
  //   name: 'GoogleBasicBarChart',
  //   ...GoogleBasicBarChart,
  // },
  // { name: 'GoogleStackedChart', ...GoogleStackedChart },
  // { name: 'GoogleCustomColorChart', ...GoogleCustomColorChart },
  // { name: 'GoogleComboChart', ...GoogleComboChart },
  // { name: 'GoogleLineChart', ...GoogleLineChart },
  // { name: 'GoogleMultiLineChart', ...GoogleMultiLineChart },
  // { name: 'GoogleBasicPieChart', ...GoogleBasicPieChart },
  // { name: 'Google3dPieChart', ...Google3dPieChart },
  // { name: 'BubbleChart', ...BubbleChart },
  // {
  //   name: "ChartjsStackedChart",
  //   ...ChartjsStackedChart,
  // },
  Alerts,
  // CreateProject,
  Button,
  BtnGroup,
  Drawer,
  CalendarButton,
  ExportButton,
  ShareButton,
  { name: 'PageHeader', ...PageHeader },
  Cascader,
  AutoComplete,
  Dropdown,
  Popover,
  FeatherIcons,
  Modal,
  // eslint-disable-next-line array-callback-return
].map((c) => {
  app.component(`sd${c.name}`, c);
});
